module.exports = __webpack_public_path__ + "teqbahn-assets/media/bg_v2.bcca6815.png";